import { render } from "./PdfViewerDialog.vue?vue&type=template&id=d3433be0&scoped=true"
import script from "./PdfViewerDialog.vue?vue&type=script&lang=js"
export * from "./PdfViewerDialog.vue?vue&type=script&lang=js"

import "./PdfViewerDialog.vue?vue&type=style&index=0&id=d3433be0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3433be0"]])

export default __exports__